import { render } from "./neworder.vue?vue&type=template&id=22903585"
import script from "./neworder.vue?vue&type=script&lang=js"
export * from "./neworder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tommygrimm/IdeaProjects/eurogate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__